import { RemoveComponent }                   from '../../app-lite/table/cell-components/actions/remove.component';
import { TableTextControlComponent }         from '../../app-lite/table/cell-components/controls/text-control/table-text-control.component';
import { TableVendorSearchControlComponent } from '../../app-lite/table/cell-components/controls/typeahead-control/table.vendor-search.control.component';

import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function OrderingFromInvoiceCtrl (
  $scope,
  $uibModalInstance,
  $translate,
  streamSearch,
  invoice,
  items
) {

  $scope.invoice       = invoice;
  $scope.invoice_items = items;

  $scope.alternateSupplier = {
    id         : '',
    vendor_name: ''
  };

  $scope.tableSettings = {
    columns: [
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: item => $scope.removeItem(item)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false,
      },
      {
        field : 'item_code',
        header: {
          text: $translate.instant('PRODUCT_SPACE.ITEM_CODE')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        classes: [ 'text-right' ],
        field  : 'qty_available',
        header : {
          classes: [ 'text-right'],
          text   : $translate.instant('PRODUCT_SPACE.SOH')
        },
        pipe: 'number',
      },
      {
        component: {
          bindings: {
            inputs: {
              model: 'company_name',
              name : 'company_name'
            },
            outputs: {
              onSelect: selection => $scope.setVendor(selection.vendor, selection.row, selection.index)
            }
          },
          enabled: true,
          factory: TableVendorSearchControlComponent
        },
        field : 'company_name',
        header: {
          text: $translate.instant('VENDOR_SPACE.SUPPLIER')
        }
      },
      {
        classes  : [ 'text-right' ],
        component: {
          bindings: {
            inputs: {
              model: 'quantity',
              name : 'quantity',
              type : 'number'
            }
          },
          enabled: true,
          factory: TableTextControlComponent
        },
        field : 'quantity',
        header: {
          classes: [ 'text-right'],
          text   : $translate.instant('PRODUCT_SPACE.ORDER')
        },
        pipe: 'number',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ITEMS_FOUND')
    },
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.confirm = function () {
    $uibModalInstance.close({
      invoice_id   : $scope.invoice.id,
      invoice_items: $scope.invoice_items
    });
  };

  $scope.updateAllSuppliers = function () {
    angular.forEach($scope.invoice_items, item => {
      item.vendor_id    = $scope.alternateSupplier.id;
      item.company_name = $scope.alternateSupplier.vendor_name;
    });
  };

  $scope.removeAllItemsWithStock = function () {
    var newItems = [];

    angular.forEach($scope.invoice_items, item => {
      if (item.qty_available <= 0) {
        newItems.push(item);
      };
    });

    $scope.invoice_items = newItems;
  };

  $scope.removeItem = function ( row ) {
    $scope.invoice_items = $scope.invoice_items
    .filter(item => item.invoice_item_id !== row.invoice_item_id);
  };

  $scope.setVendor = function ( vendor, row, index ) {
    $scope.invoice_items[index].vendor_id    = vendor.id;
    $scope.invoice_items[index].company_name = vendor.company_name;
  };

  $scope.vendorSearchAll = {
    list  : [],
    search: typed => streamSearch.search('vendors', typed)
      .then(vendors => $scope.vendorSearchAll.list.concat(vendors)),
    choose (vendor) {
      $scope.alternateSupplier.id = vendor.id;
      $scope.alternateSupplier.vendor_name = vendor.company_name;
    },
    format     : vendor => vendor ? vendor.company_name : '',
    templateUrl: VendorSearchResultsHtml
  };

}